module.exports = __webpack_public_path__ + "img/vknows.f05f1a62.png";